import { HStack, Icon, Text } from '@genial/components';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

interface DocumentsListingRefreshButtonProps {
  onRefresh: () => void;
  isRefreshing?: boolean;
}

const LISTING_ACTION_HEIGHT = 36;

const styles = StyleSheet.create({
  pressable: {
    alignSelf: 'center',
  },
  pressableDisabled: {
    opacity: 0.4,
  },
  container: {
    height: LISTING_ACTION_HEIGHT,
    maxHeight: LISTING_ACTION_HEIGHT,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export const DocumentsListingRefreshButton: React.FC<DocumentsListingRefreshButtonProps> = ({
  onRefresh,
  isRefreshing,
}) => (
  <Pressable
    testID={
      isRefreshing ? 'documents-listing-refresh-button-loading' : 'documents-listing-refresh-button'
    }
    onPress={onRefresh}
    disabled={isRefreshing}
    style={[styles.pressable, isRefreshing ? styles.pressableDisabled : null]}>
    <View style={styles.container}>
      <HStack space="12px" alignItems="center">
        <Icon name="RefreshAlt" size="xxxs" color="neutral.black" />
        <Text variant="semibold" color="neutral.black">
          Atualizar
        </Text>
      </HStack>
    </View>
  </Pressable>
);
